export const HANDOVER_SESSION_KEY = "handoverSession";
export const LOGOUT_TIMER_REFRESH = "logoutTimerRefresh";
export const LOGOUT_TIMER_START_KEY = "logoutModalStart";
export const LOGOUT_TIME_KEY = "logoutTime";

export const HANDOVER_LOGOUT_MS = 60 * 60 * 1000;

export const refreshLogoutTimer = () => {
  localStorage.setItem(LOGOUT_TIMER_START_KEY, String(Date.now()));
  window.dispatchEvent(new Event(LOGOUT_TIMER_REFRESH));
};

export const refreshLogoutTimerForHandover = () => {
  localStorage.setItem(HANDOVER_SESSION_KEY, "true");
  refreshLogoutTimer();
};

export const getSessionLogoutDuration = (logoutTimeMs: number) =>
  localStorage.getItem(HANDOVER_SESSION_KEY)
    ? HANDOVER_LOGOUT_MS
    : logoutTimeMs;

export const getRemainingMs = (startMs: number, sessionDurationMs: number) => {
  const remaining = startMs + sessionDurationMs - Date.now();
  if (remaining <= 0) return 0;
  return remaining - (remaining % 1000);
};

export const getStoredLogoutTimeMs = (): number | null => {
  const minutes = Number(localStorage.getItem(LOGOUT_TIME_KEY));
  if (!Number.isFinite(minutes) || minutes <= 0) return null;
  return minutes * 60 * 1000;
};

export const getSessionRemainingMs = (logoutTimeMs: number): number | null => {
  const startRaw = localStorage.getItem(LOGOUT_TIMER_START_KEY);
  if (!startRaw) return null;

  const startMs = Number(startRaw);
  if (!Number.isFinite(startMs) || startMs <= 0) return null;

  return getRemainingMs(startMs, getSessionLogoutDuration(logoutTimeMs));
};
